// Mirrors backend App\Enums\Menu\MenuType

export type MenuType = 'dine-in' | 'catering'

export const MenuType = {
  DINE_IN: 'dine-in',
  CATERING: 'catering'
} satisfies Record<string, MenuType>

export const MenuTypeValues: readonly MenuType[] = Object.values(MenuType)
